import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/shareIcons/calendar-arrow-from.svg'


const _hoisted_1 = {
  key: 0,
  class: "justify-center flex-row"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = { class: "pad-m main-h bg-0 font-m" }
const _hoisted_4 = { class: "main-h bg-0 font-m" }
const _hoisted_5 = {
  key: 2,
  class: "rowcenter"
}
const _hoisted_6 = { class: "main-h bg-0 font-m" }
const _hoisted_7 = {
  key: 1,
  class: "rowcenter w-full mtop-08 es-appointment-type gap-05"
}

import { ref, watch, computed, onMounted } from 'vue';
import { DateFormat, ItemSelect, ItemTag } from '@/models/share.model';
import { AppointmentTypeApi, AppointmentTypeResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useAppUserStore } from '@/stores/appUser';
import StringService from '@/services/StringService';
import { useI18n } from 'vue-i18n';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'esCalendarHeader',
  props: {
    itemTag: {},
    displayInitial: { type: Boolean },
    displayCreateAppointment: { type: Boolean },
    patient: {},
    getAppointmentmentTypes: { type: Boolean, default: true },
    displayPatient: { type: Boolean, default: true },
    selectedAppointmentType: {},
    unselectAppointmentType: { type: Boolean, default: false }
  },
  emits: ['selectAppointmentType', 'patientTagClick', 'setUnselectedAppointmentType', 'refreshCalendar'],
  setup(__props: any, { emit: __emit }) {

const currentEntryStore = useCurrentEntryStore();

const props = __props;

const emits = __emit;
const { t } = useI18n();

const appointmentTypeApi = new AppointmentTypeApi(medServerApiConfig);
const appointmentTypeList = ref<ItemTag[]>([]);
const patient = ref<ItemSelect>();

const appUserStore = useAppUserStore();

const getIsMoveAppointmentAction = computed (() => { return currentEntryStore.isMoveAppointmentAction; });

const currInstituteUuid = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {return "";}
  return appUserStore.getCurrentInstituteWithRole().instituteWithRoleId;
});

const getInitial = (doctor: ItemTag) => {
  if (doctor && props.displayInitial) {
    const doctorData: string[] =  doctor.label.split(' ');
    if(doctorData.length === 3){
      return StringService.getInitial(doctorData[2], doctorData[1].toUpperCase()); // doctor.label = Dr Firstname LASTNAME
    }
    return StringService.getInitial(doctorData[1], doctorData[0].toUpperCase()); // doctor.label = Firstname LASTNAME
  }

  return '';
}

const transformToItemTag = (appointmentTypeResponse: AppointmentTypeResponse): ItemTag => {
  return {
    id: appointmentTypeResponse.appointmentTypeId,
    label: appointmentTypeResponse.name,
    opened: false,
    selected: false,
    appointmentTypeDoctorId: props.itemTag.id,
    itemTagColors: {
      textColor: appointmentTypeResponse.color.textColor,
      disabledTextColor: appointmentTypeResponse.color.disabledTextColor,
      backgroundColor: appointmentTypeResponse.color.backgroundColor,
      disabledBackgroundColor: appointmentTypeResponse.color.disabledBackgroundColor
    }
  }
}

const getAllAppointmentTypes = (doctorId: string) => {
  if (currInstituteUuid.value) {
    appointmentTypeApi.listAppointmentTypes({
        instituteId: currInstituteUuid.value,
        doctorId: doctorId,
        isSetting: false
    }).then((response: AppointmentTypeResponse[]) => {
      const appointmentTypes =  response.map(appointmentTypeResponse => transformToItemTag(appointmentTypeResponse));

      if (appointmentTypes.length > 0) {
        appointmentTypes.forEach((appointmentType) => {
          appointmentType.selected = false;
          appointmentType.opened = !getIsMoveAppointmentAction.value || (props.selectedAppointmentType && props.selectedAppointmentType.id === appointmentType.id);
      });}

      appointmentTypeList.value = appointmentTypes;

      if (props.selectedAppointmentType) {
        selectAppointmentType(props.selectedAppointmentType, false);
      }
    })
  }
}

const selectAppointmentType = (typeItem: ItemTag, emitChange: boolean) => {
  const index = appointmentTypeList.value.findIndex((appointmentType)=> appointmentType.id === typeItem.id);

  if (index > -1) {
    appointmentTypeList.value.forEach((appointmentType) => appointmentType.selected = false);
    appointmentTypeList.value[index].selected = true;

    if (emitChange) {
      emits('selectAppointmentType', {appointmentType: typeItem, doctor: props.itemTag});
    } 
  }
}

const getPatient = (): ItemTag[] => {
  if (props.patient) {
    return [{
      id: props.patient.id,
      label: props.patient.label,
      opened: false,
      selected: false
    }]
  }
}

const getAppointmentDate = (): string => {
  return currentEntryStore.moveAppointmentFromCalendar ? format(new Date(currentEntryStore.moveAppointmentFromCalendar.date), DateFormat.FRONT_LONG) : null;
}

async function accessPatient() {
  const patientId = props.patient.id;
  currentEntryStore.openPatientModal("appointments");
  await currentEntryStore.setModalPatient(patientId);
}

watch(
    () => props.itemTag,
  async () => {
    if (props.itemTag && props.itemTag.opened && props.patient && props.getAppointmentmentTypes) {
      await getAllAppointmentTypes(props.itemTag.id);
    }
  }
);

watch(
    () => props.patient,
  async () => {
    if (props.patient  == undefined) {
      appointmentTypeList.value = [];
      patient.value = undefined;
    } else if ((patient.value === undefined || props.patient.id !== patient.value.id ) && props.itemTag && props.itemTag.opened && props.getAppointmentmentTypes) {
      patient.value = props.patient;
      await getAllAppointmentTypes(props.itemTag.id);
    }
  }
);

watch(
    () => props.getAppointmentmentTypes,
  async () => {
    if (props.itemTag && props.itemTag.opened && props.patient && props.getAppointmentmentTypes) {
      await getAllAppointmentTypes(props.itemTag.id);
    }
  }
);

watch(
  () => props.selectedAppointmentType,
  () => {
    if (props.selectedAppointmentType) {
      selectAppointmentType(props.selectedAppointmentType, false);
    } 
  }
);

watch(
  () => props.unselectAppointmentType,
  () => {
    if (props.unselectAppointmentType) {
      appointmentTypeList.value.forEach((appointmentType) => appointmentType.selected = false);
      emits('selectAppointmentType', { doctorId: props.itemTag, appointmentType: null });
      emits('setUnselectedAppointmentType', false);
      emits('refreshCalendar');
    }
  }
)

onMounted(async () => {
  if (props.itemTag && props.itemTag.opened && props.patient && props.getAppointmentmentTypes) {
      await getAllAppointmentTypes(props.itemTag.id);
    }
});

return (_ctx: any,_cache: any) => {
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_es_doctor_item = _resolveComponent("es-doctor-item")!
  const _component_es_tag_list = _resolveComponent("es-tag-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full", getPatient() ? 'mtop-04' : 'mtop-08'])
  }, [
    (_ctx.displayCreateAppointment && patient.value && _ctx.displayPatient && getPatient())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (getIsMoveAppointmentAction.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(getIsMoveAppointmentAction.value ? _unref(t)('calendar.header.moveAppointment', {date: getAppointmentDate()}) : _unref(t)('calendar.header.appointment')), 1),
          (patient.value.id)
            ? (_openBlock(), _createBlock(_component_buttonGroup, {
                key: 1,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (accessPatient()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(getPatient()[0].label), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(getPatient()[0].label), 1)
              ])),
          _createVNode(_component_es_button_icon, {
            class: "mbottom-01 psides-05",
            icon: "xmark",
            folder: "shareIcons",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('patientTagClick'))),
            styles: "img-grey"
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_es_doctor_item, {
      item: _ctx.itemTag,
      initial: getInitial(_ctx.itemTag),
      class: "mtop-01 w-full justify-center"
    }, null, 8, ["item", "initial"]),
    (appointmentTypeList.value && getPatient())
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_es_tag_list, {
            items: appointmentTypeList.value,
            onTagClick: _cache[2] || (_cache[2] = ($event: any) => (selectAppointmentType($event, true))),
            "filter-opened": getIsMoveAppointmentAction.value
          }, null, 8, ["items", "filter-opened"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})